document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.querySelector("#sizechart");
  const overlay = document.querySelector(".sidebar-sizechart-overlay");
  const sidebar = document.querySelector(".sidebar-sizechart");
  const closeBtn = document.querySelector(".sidebar-sizechart-close");
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  if (trigger && overlay && sidebar) {
    // Abrir sidebar
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      overlay.style.display = "block";
      overlay.style.setProperty("display", "block", "important");
      sidebar.classList.add("open");


      document.body.style.overflowY = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    });

    // Función para cerrar
    const closeSidebar = () => {
      sidebar.classList.remove("open");
      overlay.style.setProperty("display", "none", "important");
      document.body.style.overflowY = "";
      document.body.style.overflowY = "auto";
      document.body.style.paddingRight = "0px";
    };

    // Cerrar al dar click en overlay o botón de cerrar
    overlay.addEventListener("click", closeSidebar);
    if (closeBtn) closeBtn.addEventListener("click", closeSidebar);
  }
});
